if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');

      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.length = this.content.length;

      this.slidesPerView = this.getSlidesPerView();
      this.currentPage = 0;
      this.totalPages = Math.ceil(this.length / this.slidesPerView);
      this.autoPlay = this.dataset.autoplay === 'true';
      this.autoSpeed = parseInt(this.dataset.speed) || 5000;
      this.autoTimer = null;

      this.updateButtons();
      this.updateSeparators();

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      window.addEventListener('resize', () => {
        this.handleResize();
      });

      if (this.autoPlay) {
        this.startAutoPlay();

        this.addEventListener('mouseenter', () => {
          this.stopAutoPlay();
        });

        this.addEventListener('mouseleave', () => {
          this.startAutoPlay();
        });
      }

    }

    getSlidesPerView() {
      return window.innerWidth < 1024
        ? 1
        : (parseInt(this.dataset.slidesPerView) || 1);
    }

    handleResize() {

      const slidesPerView = this.getSlidesPerView();

      if (slidesPerView === this.slidesPerView) return;

      this.slidesPerView = slidesPerView;
      this.totalPages = Math.ceil(this.length / this.slidesPerView);

      this.currentPage = Math.min(
        this.currentPage,
        this.totalPages - 1
      );

      this.updateButtons();
      this.updateSeparators();

      if (this.autoPlay) {
        this.startAutoPlay();
      }

      const firstIndex = this.currentPage * this.slidesPerView;

      if (this.content[firstIndex]) {
        this.slider.style.scrollSnapType = "none";

        gsap.to(this.slider, {
          scrollLeft: this.content[firstIndex].offsetLeft,
          duration: 0.8,
          ease: "power2.out",
          onComplete: () => {
            this.slider.style.scrollSnapType = "x mandatory";
          }
        });
      }

    }

    updateButtons() {

      if (this.prevButton) {
        this.prevButton.classList.toggle(
          'announcement-bar__content-nav--disabled',
          this.currentPage === 0
        );
      }

      if (this.nextButton) {
        this.nextButton.classList.toggle(
          'announcement-bar__content-nav--disabled',
          this.currentPage >= this.totalPages - 1
        );
      }

    }

    updateSeparators() {

      this.content.forEach(item => {
        item.classList.remove('announcement--last');
      });

      for (
        let i = this.slidesPerView - 1;
        i < this.content.length;
        i += this.slidesPerView
      ) {
        this.content[i].classList.add('announcement--last');
      }

    }

    changeSlide(direction) {

      if (
        direction === 'next' &&
        this.currentPage < this.totalPages - 1
      ) {
        this.currentPage++;
      }

      if (
        direction === 'prev' &&
        this.currentPage > 0
      ) {
        this.currentPage--;
      }

      const firstIndex = this.currentPage * this.slidesPerView;

      if (this.content[firstIndex]) {
        this.slider.style.scrollSnapType = "none";

        gsap.to(this.slider, {
          scrollLeft: this.content[firstIndex].offsetLeft,
          duration: 0.8,
          ease: "power2.out",
          onComplete: () => {
            this.slider.style.scrollSnapType = "x mandatory";
          }
        });
      }

      this.updateButtons();

    }

    startAutoPlay() {

      this.stopAutoPlay();

      this.autoTimer = setInterval(() => {

        if (this.currentPage >= this.totalPages - 1) {
          this.currentPage = 0;
        } else {
          this.currentPage++;
        }

        const firstIndex = this.currentPage * this.slidesPerView;

        if (this.content[firstIndex]) {
          this.slider.style.scrollSnapType = "none";

          gsap.to(this.slider, {
            scrollLeft: this.content[firstIndex].offsetLeft,
            duration: 0.8,
            ease: "power2.out",
            onComplete: () => {
              this.slider.style.scrollSnapType = "x mandatory";
            }
          });
        }

        this.updateButtons();

      }, this.autoSpeed);

    }

    stopAutoPlay() {

      if (this.autoTimer) {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }

    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}